export const setRender = () => {
    return {
        type : "SET_RENDER"
    }
}

export const setSearch = (buttonFlag) => {
    return {
        type : "SET_SEARCH",
        buttonFlag: buttonFlag
    }
}

export const setAssistente = (data) => {
    return {
        type : "SET_ASSISTENTE",
        assistente: data
    }
}

export const setStateAssistente = (id, data) => {
    return {
        type : "SET_STATE_ASSISTENTE",
        id: id,
        stateAssistente: data
    }
}
export const deleteAssistente = () => {
    return {
        type : "DELETE_ASSISTENTE"
    }
}
export const setFlagInserimentoManuale = (flagInserimentoManuale) => {
    return {
        type : "SET_FLAG_INSERIMENTO_MANUALE",
        flagInserimentoManuale:flagInserimentoManuale
    }
}

export const setParamsRicercaAssistente = (params) => {
    return {
        type : "SET_PARAMS_RICERCA",
        params: params
    }
}
export const setStateRicercaAssistente = (state) => {
    return {
        type : "SET_STATE_RICERCA",
        state: state
    }
}
export const deleteStateRicercaAssistente = () => {
    return {
        type : "DELETE_STATE_RICERCA"
    }
}
export const deleteParamsRicercaAssistente = () => {
    return {
        type : "DELETE_PARAMS_RICERCA"
    }
}
export const setUpload = (id, upload) => {
    return {
        type : "SET_UPLOAD",
        id: id,
        upload: upload
    }
}
export const deleteStateUpload = () => {
    return {
        type : "REMOVE_STATE_UPLOAD"
    }
}
export const removeSingleFile = (id,index) => {
    return {
        type : "REMOVE_ELEMENT",
        id: id,
        index: index
    }
}

export const setAnnuncio = (annuncio) => {
    return {
        type: 'SET_ANNUNCIO',
        annuncio: annuncio
    }
}

export const setStateAnnuncio = (id, stateAnnuncio) => {
    return {
        type: 'SET_STATE_ANNUNCIO',
        id: id,
        stateAnnuncio: stateAnnuncio
    }
}

export const deleteAnnuncio = () => {
    return {
        type: 'DELETE_ANNUNCIO'
    }
}
